import React from "react";
import { Panel, SectionGrid, SummaryGrid } from "../AdminAnalyticsCards";
import CssBarChart from "../charts/CssBarChart";
import AdminAnalyticsTable, { UserCell } from "../tables/AdminAnalyticsTable";
import { aa, formatDateTime, formatDay, formatLabel, formatNumber, getUserLabel, getUserSubLabel } from "../adminAnalyticsUtils";
function formatUsersSublabel(count) {
  return aa("users_sublabel", "{{count}} users", {
    count: formatNumber(count),
  });
}
export default function AdminAnalyticsGearTab({
  data
}) {
  const summary = data?.summary || {};
  const completion = data?.completionCounts || {};
  return <>
      <SummaryGrid cards={[{
      label: aa("gear_sets", "Gear sets"),
      value: formatNumber(summary.gearSets)
    }, {
      label: aa("users_with_gear", "Users with gear"),
      value: formatNumber(summary.usersWithGear)
    }, {
      label: aa("default_gear_sets", "Default gear sets"),
      value: formatNumber(summary.defaultGearSets)
    }, {
      label: aa("gear_sets_created", "Gear sets created"),
      value: formatNumber(summary.gearSetsCreated)
    }, {
      label: aa("gear_opened_users", "Gear opened users"),
      value: formatNumber(summary.gearOpenedUsers)
    }, {
      label: aa("saved_gear_applied", "Saved gear applied"),
      value: formatNumber(summary.savedGearAppliedToCatch)
    }]} />


      <SectionGrid>
        <CssBarChart title={aa("gear_activity_by_event", "Gear activity by event")} rows={data?.gearActivityByEvent} getLabel={row => row?.eventName || aa("unknown", "Unknown")} getValue={row => row?.eventCount} getSublabel={row => formatUsersSublabel(row?.uniqueUsers)} />

        <CssBarChart title={aa("gear_sets_by_day", "Gear sets by day")} rows={data?.gearSetsByDay} getLabel={row => formatDay(row?.day)} getValue={row => row?.gearSets} />

        <Panel title={aa("completion_counts", "Completion counts")}>
          <div className="admin-analytics-completion-grid">
            {[[aa("rod", "Rod"), completion.withRod], [aa("reel", "Reel"), completion.withReel], [aa("line", "Line"), completion.withLine], [aa("leader", "Leader"), completion.withLeader], [aa("lure", "Lure"), completion.withLure], [aa("hook", "Hook"), completion.withHook]].map(([label, value]) => <div className="admin-analytics-completion-item" key={label}>
                <span>{formatLabel(label)}</span>
                <strong>{formatNumber(value)}</strong>
              </div>)}
          </div>
        </Panel>
        <AdminAnalyticsTable title={aa("top_gear_users", "Top gear users")} rows={data?.topGearUsers} rowKey={row => getUserSubLabel(row)} columns={[{
        header: aa("user", "User"),
        render: row => <UserCell title={getUserLabel(row)} subtitle={getUserSubLabel(row)} />
      }, {
        header: aa("gear_sets", "Gear sets"),
        render: row => formatNumber(row?.gearSetCount)
      }, {
        header: aa("last_gear_event", "Last gear event"),
        render: row => formatDateTime(row?.lastGearEventAt)
      }]} />

      </SectionGrid>
    </>;
}
